/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ClientSaleService {
  private data: any;

  constructor() {
    this.data = {};
  }

  getData() {
    const data = JSON.parse(sessionStorage.getItem('client:sale'));
    return data;
  }

  setData(data) {
    this.data = data;
    sessionStorage.setItem('client:sale', JSON.stringify(data));
  }

  emptyData() {
    sessionStorage.removeItem('client:sale');
  }

  setDataDefault() {
    this.data = {
      id: null,
      name: 'Cliente Varios',
      identifier: 'Sin Identificar',
      idNumber: 'Sin Documento',
      address: 'Sin Dirección',
      groupLoyaltyId: 'Sin Fidelidad',
      email: 'Sin Correo',
      phone: 'Sin Telefono'
    };
    this.setData(this.data);
  }
}
